<template>
  <!--
    Card de noticia para la grilla del listado (ACHIEVERY-1363, Etapa 3).
    Toda la card es el link (detalle interno o link externo, resuelto en newsHelpers).
  -->
  <a
    class="news-card"
    :href="item.href"
    :target="item.target"
    :title="item.title"
    :data-label="`${item.cta} - ${item.title}`"
  >
    <span class="news-card__media">
      <img v-if="item.image" :src="item.image" :alt="item.imageAlt" />
    </span>
    <span class="news-card__body">
      <span class="news-card__title">{{ item.title }}</span>
      <span v-if="item.excerpt" class="news-card__excerpt">{{ item.excerpt }}</span>
      <span class="news-card__meta">
        <span v-if="item.category" class="news-card__cat">{{ item.category }}</span>
        <span v-if="item.category && item.date"> · </span>
        <span v-if="item.date">{{ item.date }}</span>
      </span>
      <span class="news-card__more">{{ item.cta }}</span>
    </span>
  </a>
</template>

<script>
export default {
  name: 'NewsCard',
  props: {
    // Objeto ya mapeado por newsHelpers.mapNewsItem.
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
